module.exports = __webpack_public_path__ + "static/img/icon-radio-checked.de08bb68.svg";